class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.resetButton.addEventListener("click", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }

    // Bind the instance to be used later in the jQuery context
    const searchFormInstance = this;
    $(".custom-search-modal").css("opacity", "1");
    $(".header__icon--search").click(function () {
      $(this)
        .parents(".header__search ")
        .find(".custom-search-modal")
        .addClass("active");
      $("body").addClass("overflow-hidden");
    });
    $(".search-modal__close-button").click(function () {
      $(".custom-search-modal").removeClass("active");
      $("body").removeClass("overflow-hidden");
    });

    $(".popular-search-item").click(function () {
      var search = $(this).find("input").val();
      $(this)
        .parents(".search-modal__content")
        .find(".search__input")
        .val(search);
      var searchval = search.toLowerCase();
      var productfound = false;
      var articlefound = false;

      $(".custom-search-modal .all-products .popular-product-item").each(
        function () {
          var tags = $(this).data("tags").toLowerCase();
          var title = $(this)
            .find(".popular-product-title")
            .html()
            .toLowerCase(); 
          if (tags.indexOf(searchval) != -1 || title.indexOf(searchval) != -1) {
            $(this).show();
            productfound = true;
          } else {
            $(this).hide();
          }
        }
      );
      var count = 0;
      $(".custom-search-modal .all-articles .article-items").each(function () {
        var tags = $(this).data("tags").toLowerCase();
        var title = $(this).find("a").html().toLowerCase();
        if (count < 3) {
          if (tags.indexOf(searchval) != -1 || title.indexOf(searchval) != -1) {
            $(this).show();
            articlefound = true;
            count = count + 1;
          } else {
            $(this).hide();
          }
        } else {
          $(this).hide();
        }
      });
      $(".all-article-label").show();
      if (articlefound == true) {
        $(".all-articles").show();
        $(".no-article-found").hide();
      } else {
        $(".all-articles").hide();
        $(".no-article-found").show();
      }

      $(".all-product-label").show();
      if (productfound == true) {
        $(".all-products").show();
        $(".no-product-found").hide();
      } else {
        $(".all-products").hide();
        $(".no-product-found").show();
      }

      $(".popular-product-label").hide();
      $(".best-seller-prod").hide();

      // Use the stored reference to call toggleResetButton
      searchFormInstance.toggleResetButton();
    });
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  onChange() {
    var searchval = $(this.input).val().toLowerCase();
    if (searchval != "") {
      var productfound = false;
      var articlefound = false;

      $(".custom-search-modal .all-products .popular-product-item").each(
        function () {
          var tags = $(this).data("tags").toLowerCase();
          var title = $(this)
            .find(".popular-product-title")
            .html()
            .toLowerCase(); 
          if (tags.indexOf(searchval) != -1 || title.indexOf(searchval) != -1) {
            $(this).show();
            productfound = true;
          } else {
            $(this).hide();
          }
        }
      );
      var count = 0;
      $(".custom-search-modal .all-articles .article-items").each(function () {
        var tags = $(this).data("tags").toLowerCase();
        var title = $(this).find("a").html().toLowerCase();
        if (count < 3) {
          if (tags.indexOf(searchval) != -1 || title.indexOf(searchval) != -1) {
            $(this).show();
            articlefound = true;
            count = count + 1;
          } else {
            $(this).hide();
          }
        } else {
          $(this).hide();
        }
      });
      $(".all-article-label").show();
      if (articlefound == true) {
        $(".all-articles").show();
        $(".no-article-found").hide();
      } else {
        $(".all-articles").hide();
        $(".no-article-found").show();
      }

      $(".all-product-label").show();
      if (productfound == true) {
        $(".all-products").show();
        $(".no-product-found").hide();
      } else {
        $(".all-products").hide();
        $(".no-product-found").show();
      }

      $(".popular-product-label").hide();
      $(".best-seller-prod").hide();
    } else {
      $(".popular-product-label").show();
      $(".best-seller-prod").show();
      $(".all-article-label").hide();
      $(".all-articles").hide();
      $(".no-article-found").hide();
      $(".all-product-label").hide();
      $(".all-products").hide();
      $(".no-product-found").hide();
    }
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.onChange();
      this.toggleResetButton();
    }
  }
}

customElements.define("search-form", SearchForm);
